import { useIntl } from 'react-intl'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import TextButton from 'LuxKit/Button/TextButton'
import PaletteSheet from 'LuxKit/PaletteSheet'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { getMerchandiseCategorySearchUrl } from '../merchandiseUtils'

const StyledResponsiveImage = styled(ResponsiveImage)`
  img {
    transition: none;
  }
`

const ImageBackgroundWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;

  &::before {
    position: absolute;
    content: '';
    z-index: 1;
    top: 0;
    left: 0;
    height: 100%;
    width: ${rem(150)};
    background: linear-gradient(to right, rgb(54 58 69), rgb(54 58 69 / 0%));
  }

  ${mediaQueryUp.tablet} {
    width: 65%;

    &::before {
      width: ${rem(400)};
    }
  }

  ${mediaQueryUp.extraLargeDesktop} {
    width: 60%;
  }

  @media (min-width: 1921px) {
    width: 55%;
  }
`

const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  padding: ${rem(64)} 0;
  width: 50%;

  ${mediaQueryUp.tablet} {
    padding: ${rem(112)} 0;
    width: 35%;
  }


  ${mediaQueryUp.extraLargeDesktop} {
    width: 40%;
  }

  @media (min-width: 1921px) {
    width: 45%;
  }
`

const MerchandiseCategoryHeroWrapper = styled.div`
  position: relative;
  background-color: ${props => props.theme.palette.neutral.default.one};
`

interface Props {
  category: App.MerchandiseCategory
}

function MerchandiseCategoryHero({ category }: Props) {
  const intl = useIntl()

  return <MerchandiseCategoryHeroWrapper>
    <ImageBackgroundWrapper>
      {!!category.image?.id && (
        <StyledResponsiveImage
          id={category.image.id}
          alt={intl.formatMessage({
            id: 'USxKGIGmV1TJh9-gxX6t',
            defaultMessage: 'Hero image',
            description: 'Alt text for merchandise category hero image in the shop section',
          })}
          mobileAspectRatio="4:3"
          tabletAspectRatio="16:9"
          fit="center"
          loading="eager"
          disablePlaceholder
        />
      )}
    </ImageBackgroundWrapper>

    <LayoutContainer>
      <ContentWrapper>
        <Group direction="vertical" gap={16} horizontalAlign="start">
          <Heading colour="neutral-eight" variant="heading1">
            {category.name}
          </Heading>

          <PaletteSheet paletteType="inverse">
            <TextButton kind="secondary" to={getMerchandiseCategorySearchUrl(category)}>
              {intl.formatMessage(
                {
                  id: '1vQ8wcmNhEq7djyJTMwP',
                  defaultMessage: 'Shop all {categoryName}',
                  description: 'Action button label to view all products in a category',
                },
                { categoryName: category.name },
              )}
            </TextButton>
          </PaletteSheet>
        </Group>
      </ContentWrapper>
    </LayoutContainer>
  </MerchandiseCategoryHeroWrapper>
}

export default MerchandiseCategoryHero
